import React from "react";
import { Link } from "react-router-dom";

export default function AssociatePartners() {
  return (
    <div className="container">
      <div className="partners-section">

        <h2>
          Associate <span>Partners</span>
        </h2>

        <p className="limit-width">
          Specialized and general physicians who have many years of work
          experience in their respective fields.
        </p>

        <ul className="partners-logo">

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-01.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-02.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-03.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-04.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-05.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-06.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-07.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-08.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-09.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-10.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-11.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/partners-logo-12.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/famphy-partners-logo-13.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/famphy-partners-logo-14.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/famphy-partners-logo-15.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/famphy-partners-logo-16.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          <li>
            <Link to="#">
              <img
                src={`${process.env.PUBLIC_URL}/img/famphy-partners-logo-17.png`}
                alt="Associate Partner"
              />
            </Link>
          </li>

          {/* Visit Health */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo visit-logo"
                src={`${process.env.PUBLIC_URL}/img/visit.png`}
                alt="Visit Health"
              />
            </Link>
          </li>

          {/* Howard Johnson */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo howard-logo"
                src={`${process.env.PUBLIC_URL}/img/howard-johnson.png`}
                alt="Howard Johnson"
              />
            </Link>
          </li>

          {/* EkinCare */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo ekincare-logo"
                src={`${process.env.PUBLIC_URL}/img/ekincare.png`}
                alt="EkinCare"
              />
            </Link>
          </li>

          {/* Connect and Heal */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo connect-logo"
                src={`${process.env.PUBLIC_URL}/img/connect-heal.png`}
                alt="Connect and Heal"
              />
            </Link>
          </li>

          {/* 7-Eleven */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo seven-eleven-logo"
                src={`${process.env.PUBLIC_URL}/img/711.png`}
                alt="7-Eleven"
              />
            </Link>
          </li>

          {/* Tata 1mg */}
          <li>
            <Link to="#">
              <img
                className="new-partner-logo tata1mg-logo"
                src={`${process.env.PUBLIC_URL}/img/tata1mg.png`}
                alt="Tata 1mg"
              />
            </Link>
          </li>

        </ul>
      </div>
    </div>
  );
}